import { Observation } from "domain";

export const initState = {
    list: [],
    current: null,
    isLoading: false,
    hasFailed: false,
    pagination: {
        total: 0,
        page: 1,
        pageSize: 20,
        hasMore: false
    }
};

export default function observationReducer(state = initState, action) {
    const { type, payload } = action;

    switch (type) {
        case 'LIST_OBSERVATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LIST_OBSERVATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LIST_OBSERVATION_FULFILLED': {
            if (payload && payload.data && payload.pagination) {
                return {
                    ...state,
                    list: payload.data.map(item => new Observation(item)),
                    pagination: payload.pagination,
                    isLoading: false,
                    hasFailed: false
                };
            } else {
                return {
                    ...state,
                    list: payload.map(item => new Observation(item)),
                    pagination: { ...initState.pagination },
                    isLoading: false,
                    hasFailed: false
                };
            }
        }
        
        case 'LOAD_MORE_OBSERVATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'LOAD_MORE_OBSERVATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'LOAD_MORE_OBSERVATION_FULFILLED': {
            if (payload && payload.data && payload.pagination) {
                return {
                    ...state,
                    list: [
                        ...state.list, 
                        ...payload.data.map(item => new Observation(item))
                    ],
                    pagination: payload.pagination,
                    isLoading: false,
                    hasFailed: false
                };
            } else {
                return state;
            }
        }

        case 'GET_OBSERVATION_PENDING': {
            return { ...state, isLoading: true, hasFailed: false };
        }

        case 'GET_OBSERVATION_REJECTED': {
            return { ...state, isLoading: false, hasFailed: true };
        }

        case 'GET_OBSERVATION_FULFILLED': {
            return {
                ...state,
                current: new Observation(payload),
                isLoading: false,
                hasFailed: false
            };
        }

        case 'CLEAR_OBSERVATION_CURRENT': {
            return {
                ...state,
                current: null
            };
        }

        default: {
            return state;
        }
    }
}